import { Inbox } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { SidebarManifest } from 'modules/core/lib/manifests/types'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    {
      identifier: 'ai_ticketing',
      name: i18n.t('ticketing.sidebar.inbox'),
      factorialOneIcon: Inbox,
      path: navigation.ticketing.fullPath(),
      group: 'it_management',
      module: 'ai_ticketing',
      priority: 'low',
    },
  ]
}
